module.exports = __webpack_public_path__ + "img/b_AnevilSirop_front.9a653b5b.jpeg";